module.exports = __webpack_public_path__ + "img/Exclusive-Workshop-Pop-up.b0dbe07a.png";